import api from '@/lib/api';
import { API_ENDPOINTS } from '@/constants/endpoints';
import { withBuScope } from '@/lib/business-unit-scope';
import type { ApiResponse } from '@/types';
import type { EscalationPolicy } from '@/modules/escalation-policy/escalation-policy';

export interface HelpdeskAgent {
  provider: string;
  id: string;
  name: string;
  email: string;
}

/** The brand's escalation policy. Saved as one object; a brand with none reads the account's. */
export const escalationPolicyService = {
  async get(scope?: { bu_id?: string }): Promise<EscalationPolicy> {
    const res = await api.get<ApiResponse<{ escalationPolicy: EscalationPolicy }>>(
      API_ENDPOINTS.BRAND.ESCALATION_POLICY,
      { params: scope }
    );
    return res.data.data.escalationPolicy ?? {};
  },

  /** The agents of the brand's connected external helpdesks — who Assign to User can assign to. */
  async helpdeskAgents(scope?: { bu_id?: string }): Promise<HelpdeskAgent[]> {
    const res = await api.get<ApiResponse<{ agents: HelpdeskAgent[] }>>(API_ENDPOINTS.BRAND.HELPDESK_AGENTS, {
      params: scope
    });
    return res.data.data.agents ?? [];
  },

  async update(escalationPolicy: EscalationPolicy, scope?: { bu_id?: string }): Promise<EscalationPolicy> {
    const res = await api.put<ApiResponse<{ escalationPolicy: EscalationPolicy }>>(
      withBuScope(API_ENDPOINTS.BRAND.ESCALATION_POLICY, scope ?? {}),
      { escalationPolicy }
    );
    return res.data.data.escalationPolicy;
  }
};
